import { render } from "./info-count.vue?vue&type=template&id=45785fef&scoped=true"
import script from "./info-count.vue?vue&type=script&lang=js"
export * from "./info-count.vue?vue&type=script&lang=js"

import "./info-count.vue?vue&type=style&index=0&id=45785fef&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45785fef"]])

export default __exports__